import React from "react";
import "./loadinAni.css";

type Props = {
  visible?: boolean;
};

const LoadinAni: React.FC<Props> = ({ visible = false }) => {
  if (!visible) return null;

  return <div className="loading-overlay animate-screen" />;
};

export default LoadinAni;